import { exportArrayToCsv } from '@/lib/csvExport';
import { prApi } from '@/services/prApi';

const COLS = [
  { key: 'pr_number', header: 'Requisition No' }, { key: 'pr_date', header: 'Raised On' }, { key: 'created_by_name', header: 'Raised By' },
  { key: 'section_name', header: 'Section' }, { key: 'required_by_date', header: 'Required By' }, { key: 'days_late', header: 'Days Late' },
  { key: 'mapped_fg_name', header: 'FG Name' }, { key: 'design_name', header: 'Design Name' }, { key: 'fg_shade', header: 'Shade' },
  { key: 'fg_size', header: 'Size' }, { key: 'fg_description', header: 'Description' },
  { key: 'unit', header: 'Unit' }, { key: 'required_qty', header: 'Required Qty' }, { key: 'ordered_qty', header: 'On POs' },
  { key: 'balance_qty', header: 'Still To Order' }, { key: 'remarks', header: 'Item Remarks' },
];

/** One CSV row per requisition line still to order (all open requisitions); returns the row count. */
export const exportPendingPrCsv = async () => {
  const rows = await prApi.openItems();
  exportArrayToCsv(rows, COLS, `pending_requisitions_${new Date().toLocaleDateString('en-CA', { timeZone: 'Asia/Kolkata' })}.csv`);
  return rows.length;
};
